/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ProcessConfigVersionModel {

        public processConfig: Wars.Domain.Model.ProcessConfiguration;
        public processType: Wars.Domain.Model.ProcessType;
        public newVersionName: string;
        public validationIssues: Array<string> = [];
        public versioning: boolean;


        constructor(
            private $location: ng.ILocationService,
            private $route: ng.route.IRouteService,
            private appTypeService: services.ProcessTypeService,
            private processConfigurationService: services.ProcessConfigurationService,
            private deleteService: services.DeleteService,
            private processConfigId: string,
            private sendConfigActivatedEvent: () => void,
            private growl: angular.growl.IGrowlService)
        {
            this.fetchProcessConfigurationsFromServer();
            this.versioning = false;
        }

        private appConfigsInPlace(): boolean {
            if (this.processType == undefined) return false;
            if (this.processType.processConfigurations == undefined) return false;
            return this.processType.processConfigurations.length > 0;
        }

        public isVersionDisabled() {
            return !this.appConfigsInPlace() || !this.newVersionName || this.versioning;
        }

        public showExistingVersions(): boolean {
            if (!this.appConfigsInPlace()) return false;
            return Enumerable.from(this.processType.processConfigurations).any(i => i.minorVersion != null);
        }

        public version(): void {
            this.processConfigurationService.version(this.processConfig.id, this.newVersionName)
                .then((result: any) => {
                    if (result.success) {
                        alert("Versioning your Process Configuration in the Background.");
                        this.versioning = true;
                        var interval = setInterval(() => {
                                this.fetchProcessConfigurationsFromServer();
                                var processConfigBeingVersioned = Enumerable.from(this.processType.processConfigurations).single(p => p.id === this.processConfig.id);
                                if (processConfigBeingVersioned.minorVersion !== null) {
                                    if (Enumerable.from(this.processType.processConfigurations).any(p => p.minorVersion === null)) {
                                        clearInterval(interval);
                                        this.growl.success(this.processType.name + " has been Versioned.", { ttl: 7000 });
                                        var newProcessConfig = Enumerable.from(this.processType.processConfigurations).single(p => p.minorVersion === null);
                                        this.versioning = false;
                                        this.$location.path('/ProcessConfiguration/' + newProcessConfig.id + '/Manage/Version');
                                    }
                                }
                            },
                            4000);

                    } else {
                        this.validationIssues = result.validationIssues;
                    }
                });
        }

        public canActivate(processConfig: Wars.Domain.Model.ProcessConfiguration): boolean {
            if (processConfig.configurationStatus !== Wars.Domain.Model.Codes.Enums.ConfigurationStatus.InWork) return false;

            var moreRecentActivatedVersionsExist = Enumerable.from(this.processType.processConfigurations)
                .where(i => i.configurationStatus === Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Activating ||
                    i.configurationStatus === Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Active)
                .where(i => i.minorVersion !== null && i.minorVersion > processConfig.minorVersion)
                .any();
            return !moreRecentActivatedVersionsExist;
        }

        public deleteProcessConfiguration(processConfig: Wars.Domain.Model.ProcessConfiguration): void {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "ProcessConfiguration",
                processConfig.id,
                "Process Configuration",
                () => {
                    this.processType.processConfigurations.remove(processConfig);
                }
            );
        }

        public beginActivation(processConfig: Wars.Domain.Model.ProcessConfiguration): void {
            if (processConfig.minorVersion == null) {
                alert("This process configuration is not versioned it cannot be activated.");
                return;
            }

            this.processConfigurationService.beginActivation(processConfig.id)
                .then((result) => {
                    if (result.success) {
                        this.sendConfigActivatedEvent();
                        var interval = setInterval(() => {
                                this.fetchProcessConfigurationsFromServer();
                                if (!Enumerable.from(this.processType.processConfigurations)
                                    .any(p => p.configurationStatus === Wars.Domain.Model.Codes.Enums.ConfigurationStatus.Activating)) {
                                    clearInterval(interval);
                                    this.growl.success(this.processType.name + " has been activated.", { ttl: 7000 });
                                }
                            },
                            4000);
                        //this.$route.reload();
                    } else {
                        if (result.validationIssues.length > 0) {
                            this.validationIssues = result.validationIssues;
                        } else {
                            this.validationIssues
                                .push("An unexpected error occurred and the process configuration could not activated.");
                        }
                    }
                });


        }

        public processConfigIsVersioned(processConfig: Wars.Domain.Model.ProcessConfiguration): boolean {
            if (!processConfig) return false;
            return processConfig.minorVersion != null;
        }

        private fetchProcessConfigurationsFromServer(): void {
            this.processConfigurationService.getById(this.processConfigId)
                .then(
                    (newProcessConfigId) => {
                        this.processConfig = newProcessConfigId;
                        this.appTypeService.getByIdEagerLoadAppConfigs(this.processConfig.processType_id)
                            .then(
                                (appType) => {
                                    this.processType = appType;
                                });
                    });
        }
    }
}